import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { HomeEditionService, HomePageConfig } from 'src/Services/API';

import { useAuth } from '../Authentication/useAuth';
import { QueryKeys } from '../types';

export const useFetchHomePageConfig = (
  extraOptions?: UseQueryOptions<HomePageConfig, AxiosError>
) => {
  const { isAuthenticated } = useAuth();

  return useQuery<HomePageConfig, AxiosError>(
    [QueryKeys.fetchHomePageConfig],
    async () => {
      return await HomeEditionService.homeEditionControllerGetHomePageConfig();
    },
    {
      onError: () => {
        toast.error('erreur lors de la récupération de la configuration de la page du launcher');
      },
      enabled: isAuthenticated,
      staleTime: 300000,
      cacheTime: 300000,
      refetchOnWindowFocus: false,
      ...extraOptions,
    }
  );
};
